angular
	.module('inputRifAmministrativo.components', [])
	.component('inputRifAmministrativo', {
		templateUrl: 'ng/components/inputRifAmministrativo/inputRifAmministrativo.html',
		bindings: {
			/** Input data **/
			inputId: '@',
			inputName: '@',
			inputClass: '@',
			formName: '=',
			bindingVariable: '=',
			/** Optional data **/
			inputDisableOn: '<',
			inputRequired: '<'
		},
		controllerAs: 'inputRifAmministrativoCtrl',
		controller: function ($scope, $translate, validationService, $timeout) {

			/** not to loose *this reference **/
			var self = this;

			self.validationService = validationService;

			self.$onInit = function () {
				console.log(self);
				self.inputDisableOn = self.inputDisableOn || false;

				//Quando viene costruito, check immediato sulla validità
				$timeout(() => {
					self.bindingVariable && self.checkRifAmministrativo(self.bindingVariable);
				}, 100)
			}

			self.$onChanges = function (changesObj) {
			}

			self.$doCheck = function () {
			}

			self.$postLink = function () {
			}

			self.$onDestroy = function () {
			}

			self.errorMsgShown = false;

			self.resetAlert = function () {
				self.errorMsgShown = false;
			}

			self.showAlertMsg = function () {
				self.errorMsgShown = !self.errorMsgShown;
			}

			self.checkRifAmministrativo = function (rifAmministrativo) {
				if (typeof (rifAmministrativo) == 'undefined') {
					self.formName[self.inputName] &&
						self.formName[self.inputName].$setValidity('rifAmministrativo', false);
					return;
				}

				if (rifAmministrativo == '') {
					if (self.inputRequired) {
						self.formName[self.inputName].$setValidity('rifAmministrativo', false);
					} else {
						self.formName[self.inputName].$setValidity('rifAmministrativo', true);
					}
					return;
				}

				if (!validationService.isValidRifAmministrativo(rifAmministrativo)) {
					self.formName[self.inputName].$setValidity('rifAmministrativo', false);
					return;
				}

				//here the field is valid, return false before this point if you got here
				self.formName &&
					self.inputName &&
					self.formName[self.inputName] &&
					self.formName[self.inputName].$setValidity('rifAmministrativo', true);

			}


		}
	});